import consumer from "./consumer"

consumer.subscriptions.create("LiveBreaksChannel", {
  connected() {
    // Called when the subscription is ready for use on the server
  },

  disconnected() {
    // Called when the subscription has been terminated by the server
  },

  received(data) {
    if (typeof window === 'undefined') {
      return
    }

    window.__liveBreaksChannelLastPayload = data

    const event = new CustomEvent('liveBreaksChannel:received', {
      detail: data
    })

    window.dispatchEvent(event)
  }
});
